import { render, staticRenderFns } from "./maintenassetfrm.vue?vue&type=template&id=425538e5"
import script from "./maintenassetfrm.vue?vue&type=script&lang=js"
export * from "./maintenassetfrm.vue?vue&type=script&lang=js"
import style0 from "./maintenassetfrm.vue?vue&type=style&index=0&id=425538e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports